import { render } from "./FormInput.vue?vue&type=template&id=d2e5738a"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=d2e5738a&lang=stylus"
script.render = render

export default script